<template>
  <div class="mobile-container">
    <TopTitle/>
    <div class="main-content">
      <div class="top-title">进行中的热门活动</div>
      <div class="organize-activity-image1">
        <div class="br-line-spacing-padding">
          <!--用于填充图片和文字的空白框-->
        </div>
        <div class="activity-title">VR沉浸体验工坊</div>
        <div class="activity-content">
          <el-button class="button-class" @click="handleBuyNow('VR沉浸体验工坊')">￥19.9</el-button>
          <span class="vr-text">每次仅限最多4人参与</span>
          <span class="people-number">参与人数：193</span>
        </div>
      </div>
      <div class="organize-activity-image2">
        <div class="br-line-spacing-padding">
          <!--用于填充图片和文字的空白框-->
        </div>
        <div class="activity-title">秋季梨树采摘活动</div>
        <div class="activity-content">
          <el-button class="button-class" @click="handleBuyNow('秋季梨树采摘活动')">￥19.9</el-button>
          <span class="vr-text">不限参与人数</span>
          <span class="people-number">参与人数：253</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted} from 'vue';
import {ElNotification} from "element-plus";
// import {useRouter} from 'vue-router';

// eslint-disable-next-line
defineOptions({
  name: 'OrganizeActivity'
});


const handleBuyNow = (product) => {
  // 直接调用 ElNotification，无需模板标签
  ElNotification({
    title: '预约提示',
    message: `即将为您预约：${product}`,
    type: 'info',
    duration: 2000,
    showClose: true
  });
};
onMounted(() => {
  // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
  // 添加触摸事件支持
});
</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
}

/* 基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  /* 隐藏横向滚动条（防止意外横向滚动） */
  overflow-x: hidden;
  /* 可选：优化滚动体验（iOS端） */
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8; /* 白色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  /* 可选：子元素之间的间距（按需调整） */
  gap: 5px;
  /*  display: flex;
    flex-direction: column;
    align-items: flex-start; !* 垂直顶部对齐 *!
    justify-content: right; !* 水平左对齐 *!*/
  top: 0;
  left: 0;
}

/*整体页面的缩进和填充*/
.main-content {
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
}

.top-title{
  font-weight: bold; /* 加粗 */
  font-size: 24px;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: right; /* 水平左对齐 */
  margin-bottom: 0.5vh;
}

/*活动背景图片*/
.organize-activity-image1 {
  background-image: url("../resource/organizeActivity1.jpg");
  border-radius: 5px;
  width: 100%;
  height: 35vh;
  background-size: 100% 100%; /* 宽度高度完全拉伸填满 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 禁止重复 */
}

.organize-activity-image2 {
  margin-top: 2vh;
  background-image: url("../resource/organizeActivity2.jpg");
  border-radius: 5px;
  width: 100%;
  height: 35vh;
  background-size: 100% 100%; /* 宽度高度完全拉伸填满 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 禁止重复 */
}

.activity-title {
  text-align: left; /* 文字左对齐 */
  margin-left: 20px;
  height: 3vh;
  color: #ffffff;
}

.activity-content {
  color: #ffffff;
  display: flex;
  border-radius: 20px 20px 5px 5px;
  text-align: left; /* 文字左对齐 */
  height: 5vh;
  align-items: center; /* 垂直顶部对齐 */
  justify-content: left; /* 水平左对齐 */
  background-color: rgba(128, 128, 128, 0.5); /* 灰色半透明 */
}

.button-class {
  margin-left: 20px;
}

.vr-text{
  margin-left: 10px;
}
.people-number{
  justify-content: right; /* 水平左对齐 */
  float: right;
  margin-right: 20px;
  margin-left: auto; /* 左填充自动达到靠右效果 */
}

/*行间距*/
.br-line-spacing-padding {
  height: 27vh;
}

</style>